import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import { useEffect } from "react";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
import Header from "./components/Header";
import Footer from "./components/Footer";
import SocialBar from "./components/SocialBar";
import Home from "./pages/Home";
import Menu from "./pages/Menu";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Subscribe from "./pages/Subscribe";
import Puzzle from "./pages/Puzzle";
import Admin from "./pages/Admin";
import PaymentSuccess from "./pages/PaymentSuccess";
import Allergens from "./pages/Allergens";
import Leaflet from "./pages/Leaflet";
import QRCodes from "./pages/QRCodes";

function App() {
  return (
    <AuthProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/menu" element={<Menu />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/subscribe" element={<Subscribe />} />
              <Route path="/puzzle" element={<Puzzle />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/allergens" element={<Allergens />} />
              <Route path="/leaflet" element={<Leaflet />} />
              <Route path="/qr-codes" element={<QRCodes />} />
            </Routes>
          </main>
          <Footer />
          <SocialBar />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
